// 产品中心的分类切换：所有产品都在服务端一次输出，这里只切显示，不占 URL。
//
// 区块在 pjax 容器里，每次页面加载后重新找一次并绑一次；onPageLoaded 同一次加载可能触发多次，
// 所以用 dataset 标记避免重复绑定（与 honor.js 同一套写法）。首屏的「全部」+ 全部可见
// 是服务端给的，所以不点分类时这段 JS 什么都不用做，禁用 JS 也仍然是一份完整的产品列表。
_iro.hooks.onPageLoaded(() => {
    const root = document.querySelector(".iro-page-products");

    if (!root || root.dataset.cateBound === "1") {
        return;
    }

    root.dataset.cateBound = "1";

    const show = (term) => {
        root.querySelectorAll(".categories li").forEach((item) => {
            item.classList.toggle("active", item.dataset.iroCate === term);
        });

        root.querySelectorAll(".product").forEach((card) => {
            const cats = (card.dataset.iroCate || "").split(",");

            card.classList.toggle("hide", term !== "" && !cats.includes(term));
        });
    };

    // 监听挂在 li 上（原版也是整行可点），按钮只负责语义与键盘可达
    root.querySelectorAll(".categories li").forEach((item) => {
        item.addEventListener("click", () => show(item.dataset.iroCate || ""));
    });
});
